/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/preset_banner_templates" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdPresetBannerTemplates } from "./constants";
import type {
  EngagementAppGroupIdPresetBannerTemplatesParams,
  EngagementAppGroupIdPresetBannerTemplatesResult,
} from "./types";
import { isEngagementAppGroupIdPresetBannerTemplatesResult } from "./validators";

export const getDataTableEngagementAppGroupIdPresetBannerTemplates = reactQueryTableFetcherAdapter(
  engagementAppGroupIdPresetBannerTemplates,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: EngagementAppGroupIdPresetBannerTemplatesParams
  ): Promise<EngagementAppGroupIdPresetBannerTemplatesResult> => {
    return fetch(
      `/engagement/${appGroupId}/preset_banner_templates`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isEngagementAppGroupIdPresetBannerTemplatesResult
);
